<template>
  <div>
    <DxPopup
      :visible="true"
      :close-on-outside-click="true"
      :show-close-button="true"
      class="DxPopup popUp-custom"
      :wrapper-attr="{ class: 'albaran-popup' }"
      width="730"
      height="auto"
      :title-template="'customTitle'"
      container=".dx-viewport"
      @hiding="hide"
    >
      <template #customTitle>
        <div class="custom-popup-title">
          <div class="popup-icon">
            <div class="icon-bg"></div>
            <div class="icon-flask"></div>
            <div class="icon-check"></div>
          </div>
        </div>
      </template>
      <div class="popup-content">
        <h2 class="popup-title">
          {{ $t('materialRequest.pendingApprovalContactSoon') }}
        </h2>
        <h3 class="popup-subTitle">{{ requestCode }}</h3>
        <div class="popup-actions">
          <f7-button
            class="btn-secondary margin-right"
            type="default"
            @click="hide"
          >
            {{ $t('OK') }}
          </f7-button>
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import EventBus from '@/services/event-bus';

export default {
  components: {
    DxPopup,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('samplesRegisterModule', [
      'confirmPopup',
      'sampleCodeInfoPopUp',
    ]),
    ...mapState('materialRequest', ['requestCode']),
  },
  methods: {
    hide() {
      this.setConfirmPopup(false);
    },
    async confirmAcceptance() {
      try {
        this.$f7.preloader.show();
        EventBus.$emit('changeTab', 1);
        EventBus.$emit('showBottom', true);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
        this.hide();
      }
    },
    ...mapActions('materialRequest', [
      'setAcceptRequestPopup',
      'registerMaterialRequest',
      'setConfirmPopup',
    ]),
  },
};
</script>

<style scoped>
.custom-popup-title {
  background: transparent; /* eliminamos el fondo azul */
  padding: 24px 10px 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-icon {
  position: relative;
  width: 100px; /* ajusta según Figma */
  height: 100px;
}
.icon-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/static/icons/Ellipse 3.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}
.icon-flask {
  position: absolute;
  top: 18%;
  left: 18%;
  width: 65%;
  height: 65%;
  background-image: url('@/static/icons/confirmed_Material_request.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
}
.popup-content {
  padding: 15px 25px 25px 25px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  padding-top: 0;
}
.popup-title {
  color: var(--Neutral-70, #3e3c44);
  font-size: 20px;
  font-style: normal;
  margin-bottom: 15px;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
}
.popup-subTitle {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: var(--Neutral-70, #02973e);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}
.popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btn-accept {
  color: white;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  width: auto;
  padding: 16px;
  padding-top: 3px;
}
.btn-accept:hover {
  background: #00346a;
  transform: scale(1.05);
}

.dx-popup-title {
  border-bottom: none !important; /* quita la barra */
}
.btn-secondary {
  background-color: white !important;
  color: #00346a !important;
  border: 1px solid #00346a !important;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  width: auto;
  padding: 16px;
  padding-top: 0px;
}
.btn-secondary:hover {
  background: white;
  transform: scale(1.05);
}
.albaran-popup
  .dx-overlay-content.dx-popup-normal.dx-resizable.dx-popup-flex-height {
  width: 730px !important;
}
.albaran-popup .dx-overlay-content {
  width: 730px !important;
}
</style>
